import {
  ClientPayloadProps,
  Packages,
  stateStatusType,
  VideoProps,
  VideoViewCountProps,
} from "./actionType";

// FetchVideoEpisodeState
export interface FetchVideoDetailsState {
  isLoading: boolean;
  error: string | null;
  video_details: VideoProps | null;
  upload_Video: ClientPayloadProps | null;
  viewCount: VideoViewCountProps[] | [];
  status: stateStatusType | null;
}
export interface AddPackageToVideoState {
  isLoading: boolean;
  error: string | null;
  status: stateStatusType | null;
  videoPackage: Packages[] | [];
}
export interface GenericVideoDetailsState {
  isLoading: boolean;
  error: string | null;
  status: stateStatusType | null;
  delete: string | null;
  video_details: VideoProps | null;
}

export interface SetVideoToAnotherGroupState {
  isLoading: boolean;
  error: string | null;
  status: stateStatusType | null;
}

export const initialVideoDetailsState: FetchVideoDetailsState = {
  isLoading: false,
  error: null,
  video_details: null,
  upload_Video: null,
  viewCount: [],
  status: null,
};

export const initialGenericVideoDetailsState: GenericVideoDetailsState = {
  isLoading: false,
  error: null,
  status: null,
  delete: null,
  video_details: null,
};
export const initialAddPackageToVideoState: AddPackageToVideoState = {
  isLoading: false,
  error: null,
  status: null,
  videoPackage: [],
};

export const initialSetVideoToAnotherGroupState: SetVideoToAnotherGroupState = {
  isLoading: false,
  error: null,
  status: null,
};

export interface VideoDetailsState {
  videoDetailsState: FetchVideoDetailsState;
  genericVideoDetailsState: GenericVideoDetailsState;
  addPackageToVideoState: AddPackageToVideoState;
  setVideoToAnotherGroupState: SetVideoToAnotherGroupState;
}

export const initialState: VideoDetailsState = {
  videoDetailsState: initialVideoDetailsState,
  genericVideoDetailsState: initialGenericVideoDetailsState,
  addPackageToVideoState: initialAddPackageToVideoState,
  setVideoToAnotherGroupState: initialSetVideoToAnotherGroupState,
};
